import SchoolImage2 from "../../../../assets/images/png/individual/international/school2.webp";
import SchoolImage1 from "../../../../assets/images/png/individual/international/school3.webp";

const kickStartDataEurope = [
  {
    id: 1,
    title: (
      <>
        I am interested in <strong>Data Science + Internship</strong>
      </>
    ),
    image: SchoolImage1,
    url: "/school/data-school",
    bgColor: "#050794",
  },
  {
    id: 2,
    title: (
      <>
        I am interested in <strong>Business Analysis + Internship</strong>
      </>
    ),
    image: SchoolImage2,
    url: "/courses/business-analysis-bootcamp",
    bgColor: "#0C8F54",
  },
  //   {
  //     id: 3,
  //     title: (
  //       <>
  //         I am interested in <strong>Products Management + Internship</strong>
  //       </>
  //     ),
  //     image: SchoolImage3,
  //     url: "/courses/product-management-and-design-bootcamp",
  //     bgColor: "#7C01A7",
  //   },
  //   {
  //     id: 4,
  //     title: (
  //       <>
  //         I am interested in <strong>Cloud Development + Internship</strong>
  //       </>
  //     ),
  //     image: SchoolImage4,
  //     url: "/courses/cloud-bootcamp",
  //     bgColor: "#0E8F8F",
  //   },
];

export default kickStartDataEurope;
